import cssdHero from "../assets/images/CSSDHero.png";
import doctorGroup from "../assets/images/allDoc.png";
import labHero from "../assets/images/labHero.png";
import bloodBankHero from "../assets/images/bloodBankHero.png";
import tpaHero from "../assets/images/TPAHero.png";
import ipdHero from "../assets/images/IPDHero.png";
import ipd1 from "../assets/images/IPD1.png";
import ipd2 from "../assets/images/IPD2.png";


export const modulesData = {
   // =================================================================================================================================
  //    Section 1
  // =================================================================================================================================

  // ===========================
  // 🔵 CSSD MODULE
  // ===========================
    cssd: {
    structure: "structure1",
    maintitle: "CSSD",
    title: "Smarter Diagnostics. Faster Decisions.",
    subtitle:
      "Automate your lab processes with sample tracking, automated result entry, technician allocation, and report delivery.",
    banner: labHero,

    features: [
      { title: "Sample Tracking", text: "Track each sample from collection → report." },
      { title: "Technician Assignment", text: "One-click allocation." },
      { title: "Smart Reporting", text: "Auto-generate results." },
      { title: "Machine Integration", text: "HL7 compatible." },
    ],

    riskSection: {
      kicker: "WHY AAROGYA CSSD?",  
      title: "Your digital shield against diagnostic errors.",
      text: "Ensure accuracy, minimize manual mistakes, and deliver reliable results.",
      doctorsImg: doctorGroup,
      boxes: [
    { title: "Simplify prescription writing", text: "Et phasellus turpis..." },
    { title: "Multilingual support", text: "Et phasellus turpis..." },
    { title: "ABHA Integration", text: "Et phasellus turpis..." },
    { title: "Save & Retrieve Anytime", text: "Et phasellus turpis..." },
  ],
    },

   issueSection: {
  kicker: "Over 1500+ clients across PAN India",   // small text above title
  title: "Effortless Documentation:",
  subtitle: "Medical Certificates, MLCs & ABHA Integration", // 2nd line of heading
  image: labHero,
  features: [
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    },
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    },
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    }
  ]
}
,

   opdAdvice: [
  {
    title: "Quick Access to Medication History",
    text: ""
  },
  {
    title: "Real time Stock Insights with Alternatives",
    text: ""
  },
  {
    title: "Create disease wise templates for one click prescription",
    text: ""
  }
]
,
  },
   // ===========================
  // 🔵OPD/DayCare MODULE
  // ===========================
   "opd-daycare": {
    structure: "structure1",
    maintitle: "OPD/DayCare",
    title: "Smarter Diagnostics. Faster Decisions.",
    subtitle:
      "Automate your lab processes with sample tracking, automated result entry, technician allocation, and report delivery.",
    banner: labHero,

    features: [
      { title: "Sample Tracking", text: "Track each sample from collection → report." },
      { title: "Technician Assignment", text: "One-click allocation." },
      { title: "Smart Reporting", text: "Auto-generate results." },
      { title: "Machine Integration", text: "HL7 compatible." },
    ],

    riskSection: {
      kicker: "WHY AAROGYA CSSD?",  
      title: "Your digital shield against diagnostic errors.",
      text: "Ensure accuracy, minimize manual mistakes, and deliver reliable results.",
      doctorsImg: doctorGroup,
      boxes: [
    { title: "Simplify prescription writing", text: "Et phasellus turpis..." },
    { title: "Multilingual support", text: "Et phasellus turpis..." },
    { title: "ABHA Integration", text: "Et phasellus turpis..." },
    { title: "Save & Retrieve Anytime", text: "Et phasellus turpis..." },
  ],
    },

   issueSection: {
  kicker: "Over 1500+ clients across PAN India",   // small text above title
  title: "Effortless Documentation:",
  subtitle: "Medical Certificates, MLCs & ABHA Integration", // 2nd line of heading
  image: labHero,
  features: [
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    },
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    },
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    }
  ]
}
,

   opdAdvice: [
  {
    title: "Quick Access to Medication History",
    text: ""
  },
  {
    title: "Real time Stock Insights with Alternatives",
    text: ""
  },
  {
    title: "Create disease wise templates for one click prescription",
    text: ""
  }
]
,
  },
   // ===========================
  // 🔵 LIS/RIS MODULE
  // ===========================
   "lis-ris": {
    structure: "structure1",
    maintitle: "LIS/RIS",
    title: "Smarter Diagnostics. Faster Decisions.",
    subtitle:
      "Automate your lab processes with sample tracking, automated result entry, technician allocation, and report delivery.",
    banner: labHero,

    features: [
      { title: "Sample Tracking", text: "Track each sample from collection → report." },
      { title: "Technician Assignment", text: "One-click allocation." },
      { title: "Smart Reporting", text: "Auto-generate results." },
      { title: "Machine Integration", text: "HL7 compatible." },
    ],

    riskSection: {
      kicker: "WHY AAROGYA CSSD?",  
      title: "Your digital shield against diagnostic errors.",
      text: "Ensure accuracy, minimize manual mistakes, and deliver reliable results.",
      doctorsImg: doctorGroup,
      boxes: [
    { title: "Simplify prescription writing", text: "Et phasellus turpis..." },
    { title: "Multilingual support", text: "Et phasellus turpis..." },
    { title: "ABHA Integration", text: "Et phasellus turpis..." },
    { title: "Save & Retrieve Anytime", text: "Et phasellus turpis..." },
  ],
    },

   issueSection: {
  kicker: "Over 1500+ clients across PAN India",   // small text above title
  title: "Effortless Documentation:",
  subtitle: "Medical Certificates, MLCs & ABHA Integration", // 2nd line of heading
  image: labHero,
  features: [
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    },
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    },
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    }
  ]
}
,

   opdAdvice: [
  {
    title: "Quick Access to Medication History",
    text: ""
  },
  {
    title: "Real time Stock Insights with Alternatives",
    text: ""
  },
  {
    title: "Create disease wise templates for one click prescription",
    text: ""
  }
]
,
  },

   // ===========================
  // 🔵 Pharmacy MODULE
  // ===========================
   pharmacy: {
    structure: "structure1",
    maintitle: "Pharmacy",
    title: "Smarter Diagnostics. Faster Decisions.",
    subtitle:
      "Automate your lab processes with sample tracking, automated result entry, technician allocation, and report delivery.",
    banner: labHero,

    features: [
      { title: "Sample Tracking", text: "Track each sample from collection → report." },
      { title: "Technician Assignment", text: "One-click allocation." },
      { title: "Smart Reporting", text: "Auto-generate results." },
      { title: "Machine Integration", text: "HL7 compatible." },
    ],

    riskSection: {
      kicker: "WHY AAROGYA CSSD?",  
      title: "Your digital shield against diagnostic errors.",
      text: "Ensure accuracy, minimize manual mistakes, and deliver reliable results.",
      doctorsImg: doctorGroup,
      boxes: [
    { title: "Simplify prescription writing", text: "Et phasellus turpis..." },
    { title: "Multilingual support", text: "Et phasellus turpis..." },
    { title: "ABHA Integration", text: "Et phasellus turpis..." },
    { title: "Save & Retrieve Anytime", text: "Et phasellus turpis..." },
  ],
    },

   issueSection: {
  kicker: "Over 1500+ clients across PAN India",   // small text above title
  title: "Effortless Documentation:",
  subtitle: "Medical Certificates, MLCs & ABHA Integration", // 2nd line of heading
  image: labHero,
  features: [
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    },
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    },
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    }
  ]
}
,

   opdAdvice: [
  {
    title: "Quick Access to Medication History",
    text: ""
  },
  {
    title: "Real time Stock Insights with Alternatives",
    text: ""
  },
  {
    title: "Create disease wise templates for one click prescription",
    text: ""
  }
]
,
  },
   // ===========================
  // 🔵 Doctor MODULE
  // ===========================
   doctor: {
    structure: "structure1",
    maintitle: "Doctor",
    title: "Smarter Diagnostics. Faster Decisions.",
    subtitle:
      "Automate your lab processes with sample tracking, automated result entry, technician allocation, and report delivery.",
    banner: labHero,

    features: [
      { title: "Sample Tracking", text: "Track each sample from collection → report." },
      { title: "Technician Assignment", text: "One-click allocation." },
      { title: "Smart Reporting", text: "Auto-generate results." },
      { title: "Machine Integration", text: "HL7 compatible." },
    ],

    riskSection: {
      kicker: "WHY AAROGYA CSSD?",  
      title: "Your digital shield against diagnostic errors.",
      text: "Ensure accuracy, minimize manual mistakes, and deliver reliable results.",
      doctorsImg: doctorGroup,
      boxes: [
    { title: "Simplify prescription writing", text: "Et phasellus turpis..." },
    { title: "Multilingual support", text: "Et phasellus turpis..." },
    { title: "ABHA Integration", text: "Et phasellus turpis..." },
    { title: "Save & Retrieve Anytime", text: "Et phasellus turpis..." },
  ],
    },

   issueSection: {
  kicker: "Over 1500+ clients across PAN India",   // small text above title
  title: "Effortless Documentation:",
  subtitle: "Medical Certificates, MLCs & ABHA Integration", // 2nd line of heading
  image: labHero,
  features: [
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    },
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    },
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    }
  ]
}
,

   opdAdvice: [
  {
    title: "Quick Access to Medication History",
    text: ""
  },
  {
    title: "Real time Stock Insights with Alternatives",
    text: ""
  },
  {
    title: "Create disease wise templates for one click prescription",
    text: ""
  }
]
,
  },
   

  // ===========================
  // 🔵 BLOOD BANK MODULE
  // ===========================
   bloodbank: {
    structure: "structure1",
    maintitle: "Blood Bank",
    title: "Smarter Diagnostics. Faster Decisions.",
    subtitle:
      "Automate your lab processes with sample tracking, automated result entry, technician allocation, and report delivery.",
    banner: labHero,

    features: [
      { title: "Sample Tracking", text: "Track each sample from collection → report." },
      { title: "Technician Assignment", text: "One-click allocation." },
      { title: "Smart Reporting", text: "Auto-generate results." },
      { title: "Machine Integration", text: "HL7 compatible." },
    ],

    riskSection: {
      kicker: "WHY AAROGYA CSSD?",  
      title: "Your digital shield against diagnostic errors.",
      text: "Ensure accuracy, minimize manual mistakes, and deliver reliable results.",
      doctorsImg: doctorGroup,
      boxes: [
    { title: "Simplify prescription writing", text: "Et phasellus turpis..." },
    { title: "Multilingual support", text: "Et phasellus turpis..." },
    { title: "ABHA Integration", text: "Et phasellus turpis..." },
    { title: "Save & Retrieve Anytime", text: "Et phasellus turpis..." },
  ],
    },

   issueSection: {
  kicker: "Over 1500+ clients across PAN India",   // small text above title
  title: "Effortless Documentation:",
  subtitle: "Medical Certificates, MLCs & ABHA Integration", // 2nd line of heading
  image: labHero,
  features: [
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    },
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    },
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    }
  ]
}
,

   opdAdvice: [
  {
    title: "Quick Access to Medication History",
    text: ""
  },
  {
    title: "Real time Stock Insights with Alternatives",
    text: ""
  },
  {
    title: "Create disease wise templates for one click prescription",
    text: ""
  }
]
,
  },

  // ===========================
  // 🔵 LAB TECHNICIAN MODULE
  // ===========================
  "lab-technician": {
    structure: "structure1",
    maintitle: "Lab/Technician",
    title: "Smarter Diagnostics. Faster Decisions.",
    subtitle:
      "Automate your lab processes with sample tracking, automated result entry, technician allocation, and report delivery.",
    banner: labHero,

    features: [
      { title: "Sample Tracking", text: "Track each sample from collection → report." },
      { title: "Technician Assignment", text: "One-click allocation." },
      { title: "Smart Reporting", text: "Auto-generate results." },
      { title: "Machine Integration", text: "HL7 compatible." },
    ],

    riskSection: {
      kicker: "WHY AAROGYA CSSD?",  
      title: "Your digital shield against diagnostic errors.",
      text: "Ensure accuracy, minimize manual mistakes, and deliver reliable results.",
      doctorsImg: doctorGroup,
      boxes: [
    { title: "Simplify prescription writing", text: "Et phasellus turpis..." },
    { title: "Multilingual support", text: "Et phasellus turpis..." },
    { title: "ABHA Integration", text: "Et phasellus turpis..." },
    { title: "Save & Retrieve Anytime", text: "Et phasellus turpis..." },
  ],
    },

   issueSection: {
  kicker: "Over 1500+ clients across PAN India",   // small text above title
  title: "Effortless Documentation:",
  subtitle: "Medical Certificates, MLCs & ABHA Integration", // 2nd line of heading
  image: labHero,
  features: [
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    },
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    },
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    }
  ]
}
,

   opdAdvice: [
  {
    title: "Quick Access to Medication History",
    text: ""
  },
  {
    title: "Real time Stock Insights with Alternatives",
    text: ""
  },
  {
    title: "Create disease wise templates for one click prescription",
    text: ""
  }
]
,
  },

  // ===========================
  // 🔵 TPA MODULE
  // ===========================
    tpa: {
    structure: "structure1",
    maintitle: "TPA",
    title: "Smarter Diagnostics. Faster Decisions.",
    subtitle:
      "Automate your lab processes with sample tracking, automated result entry, technician allocation, and report delivery.",
    banner: labHero,

    features: [
      { title: "Sample Tracking", text: "Track each sample from collection → report." },
      { title: "Technician Assignment", text: "One-click allocation." },
      { title: "Smart Reporting", text: "Auto-generate results." },
      { title: "Machine Integration", text: "HL7 compatible." },
    ],

    riskSection: {
      kicker: "WHY AAROGYA CSSD?",  
      title: "Your digital shield against diagnostic errors.",
      text: "Ensure accuracy, minimize manual mistakes, and deliver reliable results.",
      doctorsImg: doctorGroup,
      boxes: [
    { title: "Simplify prescription writing", text: "Et phasellus turpis..." },
    { title: "Multilingual support", text: "Et phasellus turpis..." },
    { title: "ABHA Integration", text: "Et phasellus turpis..." },
    { title: "Save & Retrieve Anytime", text: "Et phasellus turpis..." },
  ],
    },

   issueSection: {
  kicker: "Over 1500+ clients across PAN India",   // small text above title
  title: "Effortless Documentation:",
  subtitle: "Medical Certificates, MLCs & ABHA Integration", // 2nd line of heading
  image: labHero,
  features: [
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    },
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    },
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    }
  ]
}
,

   opdAdvice: [
  {
    title: "Quick Access to Medication History",
    text: ""
  },
  {
    title: "Real time Stock Insights with Alternatives",
    text: ""
  },
  {
    title: "Create disease wise templates for one click prescription",
    text: ""
  }
]
,
  },


   // =================================================================================================================================
  //    Section 2
  // =================================================================================================================================

    // ===========================
  // 🔵 IPD & IMERGENCY
  // ===========================
   ipd: {
    structure: "structure2",

    maintitle: "IPD & IMERGENCY",
    title: "IPD & Emergency",
    subtitle: "Connecting Every Point of Patient Care",
    banner: ipdHero,

    /* =====================
       OPD / ADVICE SECTION
    ===================== */
    opdAdvice: [
      {
        title: "Doctor Consultation",
        text:
          "Structured doctor notes, prescriptions, and visit history."
      },
      {
        title: "Lab Investigation",
        text:
          "Seamless lab test ordering and result tracking."
      },
      {
        title: "In-Patient Procedures",
        text:
          "Procedure scheduling, nursing notes, and progress updates."
      }
    ],

      /* =====================
       ISSUE SECTION
    ===================== */
    issueSection: {
  title: "IPD Workflow Overview",
  subtitle: "Every Transaction in Sync",

  description:
    "Bring all ledgers, vouchers, and accounts together for complete clarity and control.",

  image: ipd1,

  steps: [
    {
      step: "Step-1",
      title: "Patient Registration",
      text: "UHID creation, admission"
    },
    {
      step: "Step-2",
      title: "Bed Allocation",
      text: "Auto / manual bed assignment"
    },
    {
      step: "Step-3",
      title: "Service Management",
      text: "Package allocation, point of care services"
    },
    {
      step: "Step-4",
      title: "Billing & Discharge",
      text: "Comprehensive billing, TPA management"
    }
  ]
},

    /* =====================
       RISK SECTION
    ===================== */
    riskSection: {
  title: "Effortless Registration",
  subtitle: "Clarity in Every Click",

  image: ipd2,

  features: [
    {
      title: "UHID",
      description:
        "Seamlessly integrated with ABHA for secure and efficient patient identification",
         icon: "FaIdCard"
    },
    {
      title: "User-Friendly Interface",
      description:
        "Intuitive design for staff to process registrations effortlessly, reducing wait times",
         icon: "FaUserMd"
    },
    {
      title: "ABDM Integration",
      description:
        "Secure, real time access to Health records",
         icon: "FaHeartbeat"
    }
  ]
}

  

    
  },

   // ===========================
  // 🔵 Payroll MODULE
  // ==========================
   payroll: {
    structure: "structure2",
    maintitle: "Payroll",
    title: "IPD & Emergency",
    subtitle: "Connecting Every Point of Patient Care",
    banner: ipdHero,

    /* =====================
       OPD / ADVICE SECTION
    ===================== */
    opdAdvice: [
      {
        title: "Doctor Consultation",
        text:
          "Structured doctor notes, prescriptions, and visit history."
      },
      {
        title: "Lab Investigation",
        text:
          "Seamless lab test ordering and result tracking."
      },
      {
        title: "In-Patient Procedures",
        text:
          "Procedure scheduling, nursing notes, and progress updates."
      }
    ],

      /* =====================
       ISSUE SECTION
    ===================== */
    issueSection: {
  title: "IPD Workflow Overview",
  subtitle: "Every Transaction in Sync",

  description:
    "Bring all ledgers, vouchers, and accounts together for complete clarity and control.",

  image: ipd1,

  steps: [
    {
      step: "Step-1",
      title: "Patient Registration",
      text: "UHID creation, admission"
    },
    {
      step: "Step-2",
      title: "Bed Allocation",
      text: "Auto / manual bed assignment"
    },
    {
      step: "Step-3",
      title: "Service Management",
      text: "Package allocation, point of care services"
    },
    {
      step: "Step-4",
      title: "Billing & Discharge",
      text: "Comprehensive billing, TPA management"
    }
  ]
},

    /* =====================
       RISK SECTION
    ===================== */
    riskSection: {
  title: "Effortless Registration",
  subtitle: "Clarity in Every Click",

  image: ipd2,

  features: [
    {
      title: "UHID",
      description:
        "Seamlessly integrated with ABHA for secure and efficient patient identification",
         icon: "FaIdCard"
    },
    {
      title: "User-Friendly Interface",
      description:
        "Intuitive design for staff to process registrations effortlessly, reducing wait times",
         icon: "FaUserMd"
    },
    {
      title: "ABDM Integration",
      description:
        "Secure, real time access to Health records",
         icon: "FaHeartbeat"
    }
  ]
}

  

    
  },

   // ===========================
  // 🔵 Accounts MODULE
  // ===========================
   accounts: {
    structure: "structure2",
    maintitle: "Accounts",
    title: "IPD & Emergency",
    subtitle: "Connecting Every Point of Patient Care",
    banner: ipdHero,

    /* =====================
       OPD / ADVICE SECTION
    ===================== */
    opdAdvice: [
      {
        title: "Doctor Consultation",
        text:
          "Structured doctor notes, prescriptions, and visit history."
      },
      {
        title: "Lab Investigation",
        text:
          "Seamless lab test ordering and result tracking."
      },
      {
        title: "In-Patient Procedures",
        text:
          "Procedure scheduling, nursing notes, and progress updates."
      }
    ],

      /* =====================
       ISSUE SECTION
    ===================== */
    issueSection: {
  title: "IPD Workflow Overview",
  subtitle: "Every Transaction in Sync",

  description:
    "Bring all ledgers, vouchers, and accounts together for complete clarity and control.",

  image: ipd1,

  steps: [
    {
      step: "Step-1",
      title: "Patient Registration",
      text: "UHID creation, admission"
    },
    {
      step: "Step-2",
      title: "Bed Allocation",
      text: "Auto / manual bed assignment"
    },
    {
      step: "Step-3",
      title: "Service Management",
      text: "Package allocation, point of care services"
    },
    {
      step: "Step-4",
      title: "Billing & Discharge",
      text: "Comprehensive billing, TPA management"
    }
  ]
},

    /* =====================
       RISK SECTION
    ===================== */
    riskSection: {
  title: "Effortless Registration",
  subtitle: "Clarity in Every Click",

  image: ipd2,

  features: [
    {
      title: "UHID",
      description:
        "Seamlessly integrated with ABHA for secure and efficient patient identification",
         icon: "FaIdCard"
    },
    {
      title: "User-Friendly Interface",
      description:
        "Intuitive design for staff to process registrations effortlessly, reducing wait times",
         icon: "FaUserMd"
    },
    {
      title: "ABDM Integration",
      description:
        "Secure, real time access to Health records",
         icon: "FaHeartbeat"
    }
  ]
}

  

    
  },
   // ===========================
  // 🔵 Asset MODULE
  // ============================
   asset: {
    structure: "structure2",
    maintitle: "Asset",
    title: "IPD & Emergency",
    subtitle: "Connecting Every Point of Patient Care",
    banner: ipdHero,

    /* =====================
       OPD / ADVICE SECTION
    ===================== */
    opdAdvice: [
      {
        title: "Doctor Consultation",
        text:
          "Structured doctor notes, prescriptions, and visit history."
      },
      {
        title: "Lab Investigation",
        text:
          "Seamless lab test ordering and result tracking."
      },
      {
        title: "In-Patient Procedures",
        text:
          "Procedure scheduling, nursing notes, and progress updates."
      }
    ],

      /* =====================
       ISSUE SECTION
    ===================== */
    issueSection: {
  title: "IPD Workflow Overview",
  subtitle: "Every Transaction in Sync",

  description:
    "Bring all ledgers, vouchers, and accounts together for complete clarity and control.",

  image: ipd1,

  steps: [
    {
      step: "Step-1",
      title: "Patient Registration",
      text: "UHID creation, admission"
    },
    {
      step: "Step-2",
      title: "Bed Allocation",
      text: "Auto / manual bed assignment"
    },
    {
      step: "Step-3",
      title: "Service Management",
      text: "Package allocation, point of care services"
    },
    {
      step: "Step-4",
      title: "Billing & Discharge",
      text: "Comprehensive billing, TPA management"
    }
  ]
},

    /* =====================
       RISK SECTION
    ===================== */
    riskSection: {
  title: "Effortless Registration",
  subtitle: "Clarity in Every Click",

  image: ipd2,

  features: [
    {
      title: "UHID",
      description:
        "Seamlessly integrated with ABHA for secure and efficient patient identification",
         icon: "FaIdCard"
    },
    {
      title: "User-Friendly Interface",
      description:
        "Intuitive design for staff to process registrations effortlessly, reducing wait times",
         icon: "FaUserMd"
    },
    {
      title: "ABDM Integration",
      description:
        "Secure, real time access to Health records",
         icon: "FaHeartbeat"
    }
  ]
}

  

    
  },




  // =================================================================================================================================
  //    Section 3
  // =================================================================================================================================


    // ===========================
  //    Purchase $ Inventory
  // ===========================
"purchase-and-inventory":{
    structure: "structure3",
    maintitle: "Purchase & Inventory",   
    title: "Why Hospitals Choose HospEase",
    subtitle: "Efficient, integrated, and stress-free hospital inventory management.",
    banner: ipdHero, // path to your banner image

    features: [
      { title: "Sample Tracking", text: "Track each sample from collection → report." },
      { title: "Technician Assignment", text: "One-click allocation." },
      { title: "Smart Reporting", text: "Auto-generate results." },
      { title: "Machine Integration", text: "HL7 compatible." },
    ],

  riskSection: {
  title: "Effortless Registration",
  subtitle: "Clarity in Every Click",

  image: ipd2,

  features: [
    {
      title: "UHID",
      description:
        "Seamlessly integrated with ABHA for secure and efficient patient identification",
         icon: "FaIdCard"
    },
    {
      title: "User-Friendly Interface",
      description:
        "Intuitive design for staff to process registrations effortlessly, reducing wait times",
         icon: "FaUserMd"
    },
    {
      title: "ABDM Integration",
      description:
        "Secure, real time access to Health records",
         icon: "FaHeartbeat"
    }
  ]
}
,

   issueSection: {
  kicker: "Over 1500+ clients across PAN India",   // small text above title
  title: "Effortless Documentation:",
  subtitle: "Medical Certificates, MLCs & ABHA Integration", // 2nd line of heading
  image: labHero,
  features: [
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    },
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    },
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    }
  ]
}
,

   opdAdvice: [
  {
    title: "Quick Access to Medication History",
    text: ""
  },
  {
    title: "Real time Stock Insights with Alternatives",
    text: ""
  },
  {
    title: "Create disease wise templates for one click prescription",
    text: ""
  }
]
,
  },
   // ===========================
  // 🔵 MRD MODULE
  // ===========================
  mrd:{
    structure: "structure3",
    maintitle: "MRD",
    title: "Why Hospitals Choose HospEase",
    subtitle: "Efficient, integrated, and stress-free hospital inventory management.",
    banner: ipdHero, // path to your banner image

    features: [
      { title: "Sample Tracking", text: "Track each sample from collection → report." },
      { title: "Technician Assignment", text: "One-click allocation." },
      { title: "Smart Reporting", text: "Auto-generate results." },
      { title: "Machine Integration", text: "HL7 compatible." },
    ],

  riskSection: {
  title: "Effortless Registration",
  subtitle: "Clarity in Every Click",

  image: ipd2,

  features: [
    {
      title: "UHID",
      description:
        "Seamlessly integrated with ABHA for secure and efficient patient identification",
         icon: "FaIdCard"
    },
    {
      title: "User-Friendly Interface",
      description:
        "Intuitive design for staff to process registrations effortlessly, reducing wait times",
         icon: "FaUserMd"
    },
    {
      title: "ABDM Integration",
      description:
        "Secure, real time access to Health records",
         icon: "FaHeartbeat"
    }
  ]
}
,

   issueSection: {
  kicker: "Over 1500+ clients across PAN India",   // small text above title
  title: "Effortless Documentation:",
  subtitle: "Medical Certificates, MLCs & ABHA Integration", // 2nd line of heading
  image: labHero,
  features: [
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    },
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    },
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    }
  ]
}
,

   opdAdvice: [
  {
    title: "Quick Access to Medication History",
    text: ""
  },
  {
    title: "Real time Stock Insights with Alternatives",
    text: ""
  },
  {
    title: "Create disease wise templates for one click prescription",
    text: ""
  }
]
,
  },
   // ===========================
  // 🔵 Bio Waste MODULE
  // ===========================
   "bio-waste":{
    structure: "structure3",
    maintitle: "Bio Waste",
    title: "Why Hospitals Choose HospEase",
    subtitle: "Efficient, integrated, and stress-free hospital inventory management.",
    banner: ipdHero, // path to your banner image

    features: [
      { title: "Sample Tracking", text: "Track each sample from collection → report." },
      { title: "Technician Assignment", text: "One-click allocation." },
      { title: "Smart Reporting", text: "Auto-generate results." },
      { title: "Machine Integration", text: "HL7 compatible." },
    ],

  riskSection: {
  title: "Effortless Registration",
  subtitle: "Clarity in Every Click",

  image: ipd2,

  features: [
    {
      title: "UHID",
      description:
        "Seamlessly integrated with ABHA for secure and efficient patient identification",
         icon: "FaIdCard"
    },
    {
      title: "User-Friendly Interface",
      description:
        "Intuitive design for staff to process registrations effortlessly, reducing wait times",
         icon: "FaUserMd"
    },
    {
      title: "ABDM Integration",
      description:
        "Secure, real time access to Health records",
         icon: "FaHeartbeat"
    }
  ]
}
,

   issueSection: {
  kicker: "Over 1500+ clients across PAN India",   // small text above title
  title: "Effortless Documentation:",
  subtitle: "Medical Certificates, MLCs & ABHA Integration", // 2nd line of heading
  image: labHero,
  features: [
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    },
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    },
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    }
  ]
}
,

   opdAdvice: [
  {
    title: "Quick Access to Medication History",
    text: ""
  },
  {
    title: "Real time Stock Insights with Alternatives",
    text: ""
  },
  {
    title: "Create disease wise templates for one click prescription",
    text: ""
  }
]
,
  },
   // ===========================
  // 🔵 CRM MODULE
  // ===========================
   crm:{
    structure: "structure3",
    maintitle: "CRM",
    title: "Why Hospitals Choose HospEase",
    subtitle: "Efficient, integrated, and stress-free hospital inventory management.",
    banner: ipdHero, // path to your banner image

    features: [
      { title: "Sample Tracking", text: "Track each sample from collection → report." },
      { title: "Technician Assignment", text: "One-click allocation." },
      { title: "Smart Reporting", text: "Auto-generate results." },
      { title: "Machine Integration", text: "HL7 compatible." },
    ],

  riskSection: {
  title: "Effortless Registration",
  subtitle: "Clarity in Every Click",

  image: ipd2,

  features: [
    {
      title: "UHID",
      description:
        "Seamlessly integrated with ABHA for secure and efficient patient identification",
         icon: "FaIdCard"
    },
    {
      title: "User-Friendly Interface",
      description:
        "Intuitive design for staff to process registrations effortlessly, reducing wait times",
         icon: "FaUserMd"
    },
    {
      title: "ABDM Integration",
      description:
        "Secure, real time access to Health records",
         icon: "FaHeartbeat"
    }
  ]
}
,

   issueSection: {
  kicker: "Over 1500+ clients across PAN India",   // small text above title
  title: "Effortless Documentation:",
  subtitle: "Medical Certificates, MLCs & ABHA Integration", // 2nd line of heading
  image: labHero,
  features: [
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    },
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    },
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    }
  ]
}
,

   opdAdvice: [
  {
    title: "Quick Access to Medication History",
    text: ""
  },
  {
    title: "Real time Stock Insights with Alternatives",
    text: ""
  },
  {
    title: "Create disease wise templates for one click prescription",
    text: ""
  }
]
,
  },
   // ===========================
  // 🔵 Ambulance MODULE
  // ===========================
   ambulance:{
    structure: "structure3",
    maintitle: "Ambulance",
    title: "Why Hospitals Choose HospEase",
    subtitle: "Efficient, integrated, and stress-free hospital inventory management.",
    banner: ipdHero, // path to your banner image

    features: [
      { title: "Sample Tracking", text: "Track each sample from collection → report." },
      { title: "Technician Assignment", text: "One-click allocation." },
      { title: "Smart Reporting", text: "Auto-generate results." },
      { title: "Machine Integration", text: "HL7 compatible." },
    ],

  riskSection: {
  title: "Effortless Registration",
  subtitle: "Clarity in Every Click",

  image: ipd2,

  features: [
    {
      title: "UHID",
      description:
        "Seamlessly integrated with ABHA for secure and efficient patient identification",
         icon: "FaIdCard"
    },
    {
      title: "User-Friendly Interface",
      description:
        "Intuitive design for staff to process registrations effortlessly, reducing wait times",
         icon: "FaUserMd"
    },
    {
      title: "ABDM Integration",
      description:
        "Secure, real time access to Health records",
         icon: "FaHeartbeat"
    }
  ]
}
,

   issueSection: {
  kicker: "Over 1500+ clients across PAN India",   // small text above title
  title: "Effortless Documentation:",
  subtitle: "Medical Certificates, MLCs & ABHA Integration", // 2nd line of heading
  image: labHero,
  features: [
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    },
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    },
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    }
  ]
}
,

   opdAdvice: [
  {
    title: "Quick Access to Medication History",
    text: ""
  },
  {
    title: "Real time Stock Insights with Alternatives",
    text: ""
  },
  {
    title: "Create disease wise templates for one click prescription",
    text: ""
  }
]
,
  },
   // ===========================
  // 🔵 Receptionist MODULE
  // ===========================
   receptionist: {
    structure: "structure3",
    maintitle: "Receptionist",
    title: "Why Hospitals Choose HospEase",
    subtitle: "Efficient, integrated, and stress-free hospital inventory management.",
    banner: ipdHero, // path to your banner image

    features: [
      { title: "Sample Tracking", text: "Track each sample from collection → report." },
      { title: "Technician Assignment", text: "One-click allocation." },
      { title: "Smart Reporting", text: "Auto-generate results." },
      { title: "Machine Integration", text: "HL7 compatible." },
    ],

  riskSection: {
  title: "Effortless Registration",
  subtitle: "Clarity in Every Click",

  image: ipd2,

  features: [
    {
      title: "UHID",
      description:
        "Seamlessly integrated with ABHA for secure and efficient patient identification",
         icon: "FaIdCard"
    },
    {
      title: "User-Friendly Interface",
      description:
        "Intuitive design for staff to process registrations effortlessly, reducing wait times",
         icon: "FaUserMd"
    },
    {
      title: "ABDM Integration",
      description:
        "Secure, real time access to Health records",
         icon: "FaHeartbeat"
    }
  ]
}
,

   issueSection: {
  kicker: "Over 1500+ clients across PAN India",   // small text above title
  title: "Effortless Documentation:",
  subtitle: "Medical Certificates, MLCs & ABHA Integration", // 2nd line of heading
  image: labHero,
  features: [
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    },
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    },
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    }
  ]
}
,

   opdAdvice: [
  {
    title: "Quick Access to Medication History",
    text: ""
  },
  {
    title: "Real time Stock Insights with Alternatives",
    text: ""
  },
  {
    title: "Create disease wise templates for one click prescription",
    text: ""
  }
]
,
  },
   // ===========================
  // 🔵 Patient MODULE
  // ===========================
   patient: {
    structure: "structure3",
    maintitle: "Patient",
    title: "Why Hospitals Choose HospEase",
    subtitle: "Efficient, integrated, and stress-free hospital inventory management.",
    banner: ipdHero, // path to your banner image

    features: [
      { title: "Sample Tracking", text: "Track each sample from collection → report." },
      { title: "Technician Assignment", text: "One-click allocation." },
      { title: "Smart Reporting", text: "Auto-generate results." },
      { title: "Machine Integration", text: "HL7 compatible." },
    ],

  riskSection: {
  title: "Effortless Registration",
  subtitle: "Clarity in Every Click",

  image: ipd2,

  features: [
    {
      title: "UHID",
      description:
        "Seamlessly integrated with ABHA for secure and efficient patient identification",
         icon: "FaIdCard"
    },
    {
      title: "User-Friendly Interface",
      description:
        "Intuitive design for staff to process registrations effortlessly, reducing wait times",
         icon: "FaUserMd"
    },
    {
      title: "ABDM Integration",
      description:
        "Secure, real time access to Health records",
         icon: "FaHeartbeat"
    }
  ]
}
,

   issueSection: {
  kicker: "Over 1500+ clients across PAN India",   // small text above title
  title: "Effortless Documentation:",
  subtitle: "Medical Certificates, MLCs & ABHA Integration", // 2nd line of heading
  image: labHero,
  features: [
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    },
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    },
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    }
  ]
}
,

   opdAdvice: [
  {
    title: "Quick Access to Medication History",
    text: ""
  },
  {
    title: "Real time Stock Insights with Alternatives",
    text: ""
  },
  {
    title: "Create disease wise templates for one click prescription",
    text: ""
  }
]
,
  },
   // ===========================
  // 🔵 Administrative MODULE
  // ===========================
   administrative: {
    structure: "structure3",
    maintitle: "Administrative",
    title: "Why Hospitals Choose HospEase",
    subtitle: "Efficient, integrated, and stress-free hospital inventory management.",
    banner: ipdHero, // path to your banner image

    features: [
      { title: "Sample Tracking", text: "Track each sample from collection → report." },
      { title: "Technician Assignment", text: "One-click allocation." },
      { title: "Smart Reporting", text: "Auto-generate results." },
      { title: "Machine Integration", text: "HL7 compatible." },
    ],

  riskSection: {
  title: "Effortless Registration",
  subtitle: "Clarity in Every Click",

  image: ipd2,

  features: [
    {
      title: "UHID",
      description:
        "Seamlessly integrated with ABHA for secure and efficient patient identification",
         icon: "FaIdCard"
    },
    {
      title: "User-Friendly Interface",
      description:
        "Intuitive design for staff to process registrations effortlessly, reducing wait times",
         icon: "FaUserMd"
    },
    {
      title: "ABDM Integration",
      description:
        "Secure, real time access to Health records",
         icon: "FaHeartbeat"
    }
  ]
}
,

   issueSection: {
  kicker: "Over 1500+ clients across PAN India",   // small text above title
  title: "Effortless Documentation:",
  subtitle: "Medical Certificates, MLCs & ABHA Integration", // 2nd line of heading
  image: labHero,
  features: [
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    },
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    },
    {
      title: "Multilingual support",
      description: "Et pharetra turpis vel fermentum cursus. Cursus."
    }
  ]
}
,

   opdAdvice: [
  {
    title: "Quick Access to Medication History",
    text: ""
  },
  {
    title: "Real time Stock Insights with Alternatives",
    text: ""
  },
  {
    title: "Create disease wise templates for one click prescription",
    text: ""
  }
]
,
  },


};
